import { computed, ref } from "vue";
import { defineStore } from "pinia";
import {
  PRACTICE_CURRICULA,
  PRACTICE_CURRICULUM_KEY,
  resolvePracticeCurriculumId,
  type PracticeCurriculumId,
} from "common/practiceCurricula";
import { usePracticeLocaleStore } from "./practiceLocaleStore";

function readStoredCurriculum(): string | null {
  try {
    return localStorage.getItem(PRACTICE_CURRICULUM_KEY);
  } catch {
    return null;
  }
}

function persistCurriculum(next: PracticeCurriculumId) {
  try {
    localStorage.setItem(PRACTICE_CURRICULUM_KEY, next);
  } catch {
    /* private mode */
  }
}

export const usePracticeCurriculumStore = defineStore(
  "practiceCurriculum",
  () => {
    const localeStore = usePracticeLocaleStore();
    const curriculumId = ref<PracticeCurriculumId>(
      resolvePracticeCurriculumId(
        readStoredCurriculum(),
        localeStore.locale,
      ),
    );

    const options = computed(() => PRACTICE_CURRICULA);

    function setCurriculum(next: PracticeCurriculumId) {
      if (curriculumId.value === next) return;
      curriculumId.value = next;
      persistCurriculum(next);
    }

    return {
      curriculumId,
      options,
      setCurriculum,
    };
  },
);
